import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { HttpUtils } from "../utils/httpUtils";
import { QueryParam, ServiceUtil } from "../utils/serviceUtils";

@Injectable({
  providedIn: 'root'
})
export class ReportConfigAirService {

    protected readonly url = environment.airUrl + '/reportConfig';

    constructor(private http: HttpClient) {
    }

    getReportConfigByEquipmentType(idEssayType: number, idDocumentType: number, idEquipment: number, criteriaType: string, lang: string): Observable<any> {
        const params: QueryParam[] = [{key: 'lang', value: lang}];

        if (criteriaType) {
            params.push({key: 'criteriaType', value: criteriaType});
        }
        return this.http.get(ServiceUtil.createQueryParams(`${this.url}/essay/${idEssayType}/documentType/${idDocumentType}/equipment/${idEquipment}`, params)).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    getReportConfigByRoomType(idEssayType: number, idDocumentType: number, idRoom: number, criteriaType: string, lang: string): Observable<any> {
        const params: QueryParam[] = [{key: 'lang', value: lang}];

        if (criteriaType) {
            params.push({key: 'criteriaType', value: criteriaType});
        }        
        return this.http.get(ServiceUtil.createQueryParams(`${this.url}/essay/${idEssayType}/documentType/${idDocumentType}/room/${idRoom}`, params)).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    getReportConfigByCompressGasType(idEssayType: number, idDocumentType: number, idCompress: number, criteriaType: string, lang: string): Observable<any> {
        const params: QueryParam[] = [{key: 'lang', value: lang}];

        if (criteriaType) {
            params.push({key: 'criteriaType', value: criteriaType});
        }        
        return this.http.get(ServiceUtil.createQueryParams(`${this.url}/essay/${idEssayType}/documentType/${idDocumentType}/compressGas/${idCompress}`, params)).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
}